import { SITE } from "@/content/copy";
import { trackEvent } from "@/lib/analytics";

export default function CalendlyEmbed() {
  return (
    <div data-testid="calendly-embed" className="rounded-2xl overflow-hidden shadow-xl bg-white">
      <iframe
        title="Book a free 30-minute consultation with Clarus Partners"
        src={`${SITE.calendlyUrl}?hide_gdpr_banner=1&background_color=ffffff&text_color=0a192f&primary_color=d97757`}
        className="calendly-frame"
        loading="lazy"
        onLoad={() => trackEvent("book_consultation_view", { location: "embed" })}
      />
    </div>
  );
}
